import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import { UpdateSortingMutationPayload } from "../../../model/UpdateSortingData";
import { UploadImage } from "../../../service/api-response/UploadImage";
import {
  httpClient,
  updateSorting,
  uploadImageAndGetCdnUrl,
} from "../../../service/http";
import {
  MutateProductCategoryPayload,
  ProductCategory,
  ProductCategoryListItem,
} from "../models/product-category";

export const productCategoriesHttp = {
  getProductCategories: async (organizationKeyName?: string) => {
    const res = await httpClient<{ data: ProductCategoryListItem[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-product-categories`,
    });
    return res.data;
  },
  getProductCategory: async (organizationKeyName?: string, id?: string) => {
    const res = await httpClient<{ data: ProductCategory }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-product-categories/${id}`,
    });
    return res.data;
  },

  createProductCategory: async ({
    organizationKeyName,
    data,
  }: PostPayload<MutateProductCategoryPayload>) => {
    const res = await httpClient<{ data: { id: string } }>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/shop-product-categories`,
      data,
    });
    return res.data.id;
  },

  updateProductCategory: ({
    organizationKeyName,
    data: { id, ...rest },
  }: PutPayload<MutateProductCategoryPayload>) => {
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/shop-product-categories/${id}`,
      data: rest,
    });
  },

  archiveProductCategory: ({
    data: { id },
    organizationKeyName,
  }: DeletePayload) => {
    return httpClient<{}>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/shop-product-categories/${id}/archive`,
      data: {},
    });
  },

  uploadProductCategoryImage: async ({
    file,
    id,
    organizationKeyName,
  }: UploadImage) => {
    return uploadImageAndGetCdnUrl({
      file,
      id,
      organizationKeyName,
      apiRoute: "shop-product-categories",
    });
  },

  updateProductCategorySorting: async ({
    organizationKeyName,
    data,
  }: UpdateSortingMutationPayload) => {
    return updateSorting({
      organizationKeyName,
      apiRoute: "shop-product-categories",
      data,
    });
  },
};
